// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/components/ui/tab-view/tab.less
// module id = 2707
// module chunks = 0 1